// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CdHj","right":"styles_right__1bVMP"};